import {IAMPage} from './IAM.jsx';
export default IAMPage;
